export enum OFFER_STATUSES {
  APPLYING_EMAIL_STEP = 'APPLYING_EMAIL_STEP',
  SUCCESS_SENDING_STEP = 'SUCCESS_SENDING_STEP',
}
